/**
 * @hidden
 */
export class BookmarkBase {
    constructor() {
        this.HasChild = false;
    }
}
/**
 * @hidden
 */
export class BookmarkDestination {
    constructor() {
        // constructor
    }
}
/**
 * @hidden
 */
export class BookmarkStyles {
    constructor() {
        // constructor
    }
}
